// Initial UI locale before the logged-in user's preference is known. An explicit saved choice wins;
// otherwise fall back to the browser language (Icelandic browsers get Icelandic), else English. This
// is what lets pre-login pages (sign-in, sign-up, accept-invitation) show a localized UI. Once signed
// in, baseLayout reconciles this with the user's saved server-side preference.
export default function detectLocale() {
    var saved = window.localStorage.getItem('webcy-lang');
    if (saved === 'is' || saved === 'en') return saved;
    var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
    return nav.indexOf('is') === 0 ? 'is' : 'en';
}
